import axios from 'axios';

const store = {
  state: {},

  mutations: {},

  getters: {},

  actions: {
    async GetUserInfo({ commit }, payload) {
      try {
        return axios({
          url: `${process.env.VUE_APP_QRAVED_APP_URL}/ordering/order/bo/user`,
          method: 'patch',
          data: payload
        });
      } catch (e) {
        return e.response;
      }
    }
  }
};

export default store;
